import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-report',
  templateUrl: './account-report.component.html',
  styleUrls: ['./account-report.component.css']
})
export class AccountReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
